function loadStyles(container) {
    let headEl = document.querySelector('head');
    [...container.querySelectorAll('link')].forEach((linkEl, index) => {
        if(headEl.querySelector(`[src="${linkEl.getAttribute('src')}"]`) == null) {
            headEl.appendChild(linkEl);
        }
        
    });
}
export default loadStyles;